var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#is98tp2daa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.062 91.995A46 46 0 1 1 92.057 46a46.049 46.049 0 0 1-45.995 45.995zm0-83.039A37.044 37.044 0 1 0 83.1 46 37.082 37.082 0 0 0 46.062 8.956z",
    fill: "#F4F2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.062 87.516C68.991 87.516 87.58 68.93 87.58 46S68.99 4.484 46.062 4.484C23.133 4.484 4.546 23.07 4.546 46s18.587 41.516 41.516 41.516z",
    fill: "#F4F2F0",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.783 44.185c.618 2.4 1.744 4.833 3.827 6.173 1.198.765 2.991 1.017 3.877-.093.979-1.209.164-2.964-.465-4.374a15.933 15.933 0 0 1-.907-10.072c.58-2.428 1.733-4.691 2.187-7.14.306-1.554.267-3.347-.82-4.495-3.2-3.374-6.267 4.27-6.994 6.26a23.293 23.293 0 0 0-.705 13.74z",
    fill: "#000",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.763 30.674a23.292 23.292 0 0 0-.727 13.751c.618 2.4 1.744 4.834 3.828 6.173l.147.088c-.957.596-2.39.322-3.4-.328-2.084-1.34-3.21-3.767-3.828-6.168a23.31 23.31 0 0 1 .727-13.757c.727-1.99 3.795-9.634 6.993-6.26a.3.3 0 0 1 .028.044c-1.837 1.492-3.297 5.161-3.768 6.457z",
    fill: "#F4F2F0",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.476 45.41c.623 2.4 1.744 4.833 3.827 6.173 1.192.765 2.991 1.011 3.877-.093.973-1.214.164-2.97-.465-4.375a15.939 15.939 0 0 1-.913-10.071c.585-2.422 1.739-4.691 2.187-7.108.306-1.558.268-3.346-.825-4.495-3.194-3.373-6.261 4.265-6.994 6.26a23.292 23.292 0 0 0-.694 13.709z",
    fill: "#000",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45 31.92a23.31 23.31 0 0 0-.726 13.758c.623 2.4 1.744 4.827 3.827 6.172l.148.088c-.957.59-2.395.317-3.401-.328-2.089-1.34-3.21-3.773-3.828-6.173a23.292 23.292 0 0 1 .727-13.751c.733-1.996 3.828-9.635 6.994-6.261l.033.038c-1.837 1.471-3.297 5.14-3.773 6.458z",
    fill: "#F4F2F0",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.526 69.604c-12.182 0-20.69-6.408-24.391-11.914",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.619 69.604c12.182 0 20.695-6.408 24.391-11.914",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 55.661a10.056 10.056 0 0 0 4.965 3.341M17.296 58.598a9.525 9.525 0 0 0 5.32-3.39",
    stroke: "#0B0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "is98tp2daa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.062)",
    d: "M0 0h92v92H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.a0ca2125d33c7f29f8e3356c0ad1c4ac.svg";
export { ForwardRef as ReactComponent };